// PGCET MCA Mock 6 — Computer Awareness (questions 31–55)
const pgcetmcaComputerAwareness = [
  {
    id: 31,
    question: "Processes P1, P2, P3 and P4 arrive at time 0 with CPU bursts of 6, 8, 7 and 3 units. Using non-preemptive Shortest Job First (SJF) scheduling, the average waiting time is",
    options: ["A. 7.00", "B. 10.25", "C. 8.00", "D. 6.50"],
    answer: "A"
  },
  {
    id: 32,
    question: "Processes P1, P2 and P3 arrive at time 0 (in that order) with CPU bursts of 24, 3 and 3 units. Using FCFS scheduling, the average waiting time is",
    options: ["A. 3", "B. 17", "C. 13", "D. 27"],
    answer: "B"
  },
  {
    id: 33,
    question: "Belady's anomaly (more page faults with more frames) can occur with which page replacement algorithm?",
    options: ["A. LRU", "B. Optimal", "C. FIFO", "D. All stack-based algorithms"],
    answer: "C"
  },
  {
    id: 34,
    question: "Paging as a memory-management scheme eliminates",
    options: ["A. Internal fragmentation", "B. External fragmentation", "C. Both internal and external fragmentation", "D. Neither internal nor external fragmentation"],
    answer: "B"
  },
  {
    id: 35,
    question: "A system has a TLB with a hit ratio of 90%. The TLB access time is 10 ns and the main memory access time is 100 ns. The effective memory access time (single-level paging) is",
    options: ["A. 110 ns", "B. 115 ns", "C. 120 ns", "D. 210 ns"],
    answer: "C"
  },
  {
    id: 36,
    question: "The disk head is at cylinder 50. The request queue is 82, 170, 43, 140, 24, 16, 190. Using SSTF disk scheduling, the total head movement (in cylinders) is",
    options: ["A. 236", "B. 642", "C. 190", "D. 208"],
    answer: "D"
  },
  {
    id: 37,
    question: "In UNIX, which system call is used to create a new process?",
    options: ["A. exec()", "B. wait()", "C. fork()", "D. exit()"],
    answer: "C"
  },
  {
    id: 38,
    question: "Relation R(A, B, C, D) has the functional dependencies A → B, B → C and C → D. The candidate key of R is",
    options: ["A. A", "B. AB", "C. BC", "D. ABCD"],
    answer: "A"
  },
  {
    id: 39,
    question: "A table T has 6 rows, and its column marks contains NULL in 2 of those rows. The query SELECT COUNT(marks) FROM T; returns",
    options: ["A. 6", "B. 4", "C. 2", "D. 0"],
    answer: "B"
  },
  {
    id: 40,
    question: "Relation R(A, B) has 3 tuples and relation S(C, D) has 4 tuples. The natural join of R and S (they share no common attribute) contains",
    options: ["A. 7 tuples", "B. 0 tuples", "C. 12 tuples", "D. 3 tuples"],
    answer: "C"
  },
  {
    id: 41,
    question: "Which concurrency problem occurs when a transaction reads data written by another transaction that has not yet committed?",
    options: ["A. Lost update", "B. Phantom read", "C. Non-repeatable read", "D. Dirty read"],
    answer: "D"
  },
  {
    id: 42,
    question: "Which of the following is a Data Control Language (DCL) command in SQL?",
    options: ["A. GRANT", "B. ALTER", "C. UPDATE", "D. SELECT"],
    answer: "A"
  },
  {
    id: 43,
    question: "An attribute (or set of attributes) in one relation that refers to the primary key of another relation is called a",
    options: ["A. Candidate key", "B. Super key", "C. Alternate key", "D. Foreign key"],
    answer: "D"
  },
  {
    id: 44,
    question: "In an ER diagram, a weak entity set is represented by a",
    options: ["A. Ellipse", "B. Double rectangle", "C. Diamond", "D. Dashed ellipse"],
    answer: "B"
  },
  {
    id: 45,
    question: "The IPv4 address 172.16.5.4 belongs to which class?",
    options: ["A. Class A", "B. Class B", "C. Class C", "D. Class D"],
    answer: "B"
  },
  {
    id: 46,
    question: "Which of the following network devices operates at the Data Link layer of the OSI model?",
    options: ["A. Hub", "B. Repeater", "C. Router", "D. Switch"],
    answer: "D"
  },
  {
    id: 47,
    question: "The correct sequence of segments in the TCP three-way handshake is",
    options: ["A. SYN, SYN-ACK, ACK", "B. SYN, ACK, FIN", "C. ACK, SYN, SYN-ACK", "D. SYN, FIN, ACK"],
    answer: "A"
  },
  {
    id: 48,
    question: "The number of bits in an IPv6 address is",
    options: ["A. 32", "B. 64", "C. 128", "D. 256"],
    answer: "C"
  },
  {
    id: 49,
    question: "Which protocol translates domain names (such as www.example.com) into IP addresses?",
    options: ["A. DHCP", "B. DNS", "C. ARP", "D. SNMP"],
    answer: "B"
  },
  {
    id: 50,
    question: "The number of point-to-point links required in a fully connected mesh topology of 6 devices is",
    options: ["A. 15", "B. 30", "C. 12", "D. 36"],
    answer: "A"
  },
  {
    id: 51,
    question: "What is printed by the C statements: int a = 10, b = 3; printf(\"%d %d\", a % b, a / b); ?",
    options: ["A. 1 3", "B. 3 1", "C. 1 3.33", "D. 0 3"],
    answer: "A"
  },
  {
    id: 52,
    question: "What is printed by the C code: int i; for (i = 0; i < 5; i++); printf(\"%d\", i); ?",
    options: ["A. 0", "B. 4", "C. 5", "D. 6"],
    answer: "C"
  },
  {
    id: 53,
    question: "What is printed by the C code: int a = 10, b = 3; printf(\"%d\", a % b + a / b); ?",
    options: ["A. 3", "B. 5", "C. 13", "D. 4"],
    answer: "D"
  },
  {
    id: 54,
    question: "What is printed by the C statement printf(\"%d\", 5 & 3 | 8); ?",
    options: ["A. 9", "B. 1", "C. 8", "D. 15"],
    answer: "A"
  },
  {
    id: 55,
    question: "What is printed by the C code: int a[] = {10, 20, 30, 40}; int *p = a; p += 2; printf(\"%d\", *p + 1); ?",
    options: ["A. 21", "B. 40", "C. 30", "D. 31"],
    answer: "D"
  }
];

export default pgcetmcaComputerAwareness;
